export default {"src":"/_next/static/media/goal-garden.62d86644.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};